import { Grid } from "@mui/material";
import AdditionalContent from "./AdditionalContent";
import CancellationConditionsDictionary from "./CancellationConditionsDictionary";
import CustomerNoteTypeDictionary from "./CustomerNoteTypeDictionary";
import { CustomerTagAssigment } from "./CustomerTagAssigment";
import CustomerTagDictionary from "./CustomerTagDictionary";
import MediaTagsDictionary from "./MediaTagsDictionary";
import OrderTagDictionary from "./OrderTagDictionary";
import ProductGroupsDictionary from "./ProductGroupsDictionary";
import ProductOptionsDictionary from "./ProductOptionsDictionary";
import RegionsDictionary from "./RegionsDictionary";

const Dictionaries = () => (
  <Grid
    sx={{
      marginTop: 1,
      marginBottom: 1,
      paddingLeft: 1,
      paddingRight: 1,
    }}
  >
    <ProductOptionsDictionary />
    <ProductGroupsDictionary />
    <CancellationConditionsDictionary />
    <CustomerNoteTypeDictionary />
    <CustomerTagDictionary />
    <CustomerTagAssigment />
    <OrderTagDictionary />
    <MediaTagsDictionary />
    <RegionsDictionary />
    <AdditionalContent />
  </Grid>
);

export default Dictionaries;
